<template>
  <div>
    <label :for="field.id">{{ field.label[currentLanguage] }} <span v-if="field.required" class="required">*</span></label>
    <label class="select" :for="field.id">
      <select :name="field.name" :value="value" @input="$emit('input', $event.target.value);$emit('change', '')" :id="field.id" :disabled="disabledStatus(field.disabled)" :readonly="field.readonly" :multiple="field.multi" :required="field.required">
        <slot v-if="!value"></slot>
        <option v-for="option in field.options" :key="option.value" :value="option.value">{{ option.label[currentLanguage] }}</option>
      </select>
    </label>
    <p class="small" v-if="field.description[currentLanguage]">{{ field.description[currentLanguage] }}</p>
  </div>
</template>

<script>
export default {
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
}
</script>



// WEBPACK FOOTER //
// src/components/elements/select.vue